<template>
    <div class="index">
        <div style="margin-bottom: 10px">
            <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户添加</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

       <el-card>
           <el-form ref="ruleForm" :rules="rules" :model="form" style="margin-top: 10px">
               <el-row :gutter="10">

                   <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                       <el-form-item label="账号名称:" prop="username" label-width="90px">
                           <el-input type="text"  v-model="form.username"></el-input>
                       </el-form-item>
                   </el-col>
               </el-row>

               <el-row :gutter="10">

                   <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                       <el-form-item label="用户密码:" prop="password" label-width="90px">
                           <el-input type="password"  v-model="form.password"></el-input>
                       </el-form-item>
                   </el-col>
               </el-row>
               <el-row :gutter="10">

                   <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                       <el-form-item label="确认密码:" prop="confirm_password" label-width="90px">
                           <el-input type="password"  v-model="form.confirm_password"></el-input>
                       </el-form-item>
                   </el-col>
               </el-row>

               <el-row :gutter="10">

                   <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                       <el-form-item label="用户昵称:" label-width="90px">
                           <el-input type="text"  v-model="form.nick_name"></el-input>
                       </el-form-item>
                   </el-col>
               </el-row>
               <el-row :gutter="10">

                   <el-col el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">

                       <el-form-item label="用户角色" prop="roles_id" label-width="90px">
                           <el-select v-model="form.roles_id" placeholder="请选择" prop="roles_id"  >
                               <el-option
                                       v-for="item in options"
                                       :key="item.en_name"
                                       :label="item.cn_name"
                                       :value="item.id" >
                               </el-option>

                           </el-select>
                       </el-form-item>
                   </el-col>
               </el-row>
               <el-row :gutter="10">

                   <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" style="padding-left: 100px">
                       <el-form-item >
                           <el-button type="primary" @click="submitForm('ruleForm')">添加账户</el-button>
                       </el-form-item>
                   </el-col>
               </el-row>

           </el-form>
       </el-card>
    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";

    export default {

        data() {

            let reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,12}$/
            var validateNewPwd = (rule, value, callback) => {
                if (!reg.test(value)) {
                    alert(value)
                    callback(new Error('密码应是6-12位数字、字母或字符组合'))
                } else {
                    callback()
                }
            }
            var validateComfirmPwd = (rule, value, callback) => {
                if (!reg.test(value)) {
                    callback(new Error('密码应是6-12位数字、字母或字符组合'))
                } else if (this.form.password !== value) {
                    callback(new Error('确认密码与密码不一致'))
                } else {
                    callback()
                }
            }
            return {
                options:[],

                form: {
                    password: "",
                    roles_id:"",
                    confirm_password:"",
                    username:"",
                    nick_name:""
                },

                rules: {
                    username: [
                        {
                            required: true,
                            message: "请输入账号名称",
                            trigger: "blur",
                        }

                    ],
                    password: [
                        {
                            required: true,
                            message: "请输入密码",
                            trigger: "blur",
                        },

                        { validator: validateNewPwd, trigger: 'blur' }
                    ],
                    confirm_password: [
                        {
                            required: true,
                            message: "请输入确认密码",
                            trigger: "blur",
                        },
                        { validator: validateComfirmPwd, trigger: 'blur' }
                    ],
                    roles_id: [
                        {
                            required: true,
                            message: "请选择角色",
                            trigger: "blur",
                        },

                    ],
                },

            };
        },
        methods: {
            ...mapActions({
                addMemberAction: "addMemberAction",
            }),

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addMemberAction({
                            username: this.form.username,
                            password:this.form.password,
                            roles_id:this.form.roles_id,
                            nick_name:this.form.nick_name,
                            type:1,
                        });
                    } else {

                        console.log("error submit!!");
                        return false;
                    }
                });
            },
        },

        mounted() {
            this.addMemberAction({type:0})
        },
        computed: {
            //   ...mapState({dataIndex:"index.dataIndex"}),
            ...mapState({
                result: (state) => state.member.result,
            }),
        },
        watch: {
            result(val) {
                if(val.code==200){

                    this.options=val.data
                }
                if (val.code == 400) {
                    this.$message("账户已经存在");
                }
                if (val.code == 302) {
                    this.$message({
                        message: "恭喜你，账户添加成功",
                        type: "success",
                    });
                }
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>
